import { render, staticRenderFns } from "./BusinessUnit.vue?vue&type=template&id=f2601ac6"
import script from "./BusinessUnit.vue?vue&type=script&lang=js"
export * from "./BusinessUnit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports